module.exports = __webpack_public_path__ + "img/news9-3.c10dc375.png";